import axios from 'axios';
import axiosInterceptor from "../middleware/axiosInterceptor";
const baseURL = process.env.REACT_APP_BASE_API_URI;

export const fetchWorkflowData = async () => {
    const url = "/api/workflows";
    try {
        const response = await axiosInterceptor.get(url);
        return response.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const saveMetaData = async (PatientJson) => {
    try {
        const url = process.env.REACT_APP_BOT_API_URI + `bot-v2/addMetaData`;
        const response = await axios.post(url, PatientJson);
        return response;
    }
    catch (error) {
        console.log("Error fetching workflow component:", error);
        throw error;
    }
};

export const fetchMetaData = async (workflowId) => {
    const url = process.env.REACT_APP_BOT_API_URI + `bot-v2/getMetaData`;
    try {
        const response = await axiosInterceptor.post(url, workflowId);
        return response.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const initCall = async (data) => {
    const url = process.env.REACT_APP_BOT_API_URI + `bot-v2/initCall`;
    try {
        const response = await axiosInterceptor.post(url, data);
        return response.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const disconnectCall = async (data) => {
    const url = process.env.REACT_APP_BOT_API_URI + `bot-v2/disconnectcall`;
    try {
        const response = await axiosInterceptor.post(url, data);
        return response.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const getConvRecordingsAndMessages = async (conId) => {
    const url = process.env.REACT_APP_BASE_API_URI + `api/getConversationInfo?cid=${conId}`;
    try {
        const response = await axiosInterceptor.get(url);
        return response.data.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const getMasterComponentData = async () => {
    const url = process.env.REACT_APP_BASE_API_URI + `api/workflow/Components/master`;
    try {
        const response = await axiosInterceptor.get(url);
        return response.data.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const getComponentData = async (compName) => {
    const url = process.env.REACT_APP_BASE_API_URI + `api/workflow/Component/${compName}`;
    try {
        const response = await axiosInterceptor.get(url);
        return response.data.data;
    }
    catch (error) {
        console.error(error);
    }
};

export const saveWorkflow = async (jsonData) => {
    const url = process.env.REACT_APP_BASE_API_URI + `api/workflow/save`;
    try {
        const response = await axiosInterceptor.post(url, jsonData);
        return response;
    }
    catch (error) {
        return { error: error.sqlMessage || error };
    }
};

export const getComponentMessages = async (messageIds) => {
    const url = process.env.REACT_APP_BASE_API_URI + `api/workflow/components/messages`;
    try {
        const response = await axiosInterceptor.post(url, { messageIds });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching workflow component:", error);
        throw error;
    }
};

export const getComponentLines = async (compName) => {
    const url = process.env.REACT_APP_PROJECT_API_URI + `vsa/component`;
    const data = { componentName: compName };
    try {
        const response = await axiosInterceptor.post(url, data);
        return response;
    }
    catch (error) {
        console.error("Error fetching workflow component line FO main API:", error);
        return error;
    }
};